// generated from 22 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const deviceIdfvFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("device_idfv_filter"),
  comparison_key: z.enum([
    "1", // 18 (81.82%)
    "11", // 4 (18.18%)
  ]),
  display_name: z.string(),
  // undefined: 15 (68.18%), defined 7 (31.82%)
  // format uuid: 5 (71.43%)
  raw_value: z.string().optional(),
  // format uuid: 14 (63.64%)
  value: z.string(),
  varies_by_app_group: z.literal(false),
});
